import { gql, useMutation } from '@apollo/client'

import {
  ValidateStudentEnrollmentDocumentMutation,
  ValidateStudentEnrollmentDocumentMutationVariables,
} from './__generated__/use-validate-student-enrollment-document.graphql'

export const VALIDATE_STUDENT_ENROLLMENT_DOCUMENT_MUTATION = gql`
  mutation ValidateStudentEnrollmentDocument($input: ValidateStudentEnrollmentDocumentInput!) {
    validateStudentEnrollmentDocument(input: $input) {
      status
      rejectionReason
    }
  }
`

interface ValidateStudentEnrollmentDocumentProps {
  institution: string
  course: string
  enrollmentPeriod: string
  documentData: string
  documentName: string
  mimeType?: string
}

export const useValidateStudentEnrollmentDocument = () => {
  const [validateStudentEnrollmentDocument] = useMutation<
    ValidateStudentEnrollmentDocumentMutation,
    ValidateStudentEnrollmentDocumentMutationVariables
  >(VALIDATE_STUDENT_ENROLLMENT_DOCUMENT_MUTATION)

  return async (props: ValidateStudentEnrollmentDocumentProps) => {
    const { institution, course, enrollmentPeriod, documentData, documentName, mimeType } = props

    return validateStudentEnrollmentDocument({
      variables: {
        input: {
          institution,
          course,
          enrollmentPeriod,
          documentData,
          documentName,
          mimeType,
        },
      },
      fetchPolicy: 'network-only',
    }).then(({ data }) => data)
  }
}
